import type { DateTime, Uuid } from '@common/types/helpers';

export type ChatBotChain = {
    _id: Uuid;
    bot_id: Uuid;
    name: string;
    triggers: ChatBotChainTrigger[];
    status: number; // TODO: enum
    statistics: {
        unique: ChatBotChainStatistics;
        non_unique: ChatBotChainStatistics;
    };
    is_public: boolean;
    updated_at: DateTime;
    created_at: DateTime;
};

export type ChatBotChainEntity = {
    chainId: string;
    name: string;
    isDefault: boolean;
};

type ChatBotChainTrigger = {
    id: Uuid;
    name: string;
    type: ChatBotChainTriggerType;
};

type ChatBotChainStatistics = {
    sent: number;
    delivered: number;
    opened: number;
    redirected: number;
    clicked: number;
    rejected: number;
    partial_rejected: number;
};

export enum ChatBotChainTriggerType {
    Default = 1,
}
